import React from 'react'
import { Circles as Loader } from "react-loader-spinner";

const Circles = () => {
    return (
        <Loader
            height="30"
            width="30"
            color="#707070"
            ariaLabel="circles-loading"
            wrapperStyle={{ margin: "10px", justifyContent: "center" }}
            wrapperClass=""
            visible={true}
        />
    )
}

export default Circles